// ~~ Generated. This file cannot be edited directly. Please look at libs/nx-tooling/src/generators/backoffice-project/generator.ts

import { SuspenseLoadingWrapper } from '@backoffice-frontend/patterns'
import { BoumRight } from '@moia-dev/moia-token-claims'
import { lazy } from 'react'
import { ApServiceSettingsAreaId } from './ApServiceSettingsAreaId'
import { ApServiceSettingsAreaNavigation } from './ApServiceSettingsAreaNavigation'
import { ApServiceSettingsAreaRoutes } from './ApServiceSettingsAreaRoutes'

const LazyApServiceSettingsComponent = lazy(
  () => import('./ApServiceSettingsArea'),
)

const ApServiceSettingsComponent = () => (
  <SuspenseLoadingWrapper>
    <LazyApServiceSettingsComponent />
  </SuspenseLoadingWrapper>
)

export const ApServiceSettingsArea = {
  id: ApServiceSettingsAreaId,
  requiredRight: BoumRight.AREA_ADMIN_PANEL_SERVICE_SETTINGS,
  NavigationComponent: ApServiceSettingsAreaNavigation,
  route: {
    path: ApServiceSettingsAreaRoutes.route,
    component: ApServiceSettingsComponent,
  },
}
